module.exports = __webpack_public_path__ + "img/svg/stream-stats.36bc45ab5e2c3526779508ac6650200e.svg";